import * as React from "react";

import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import * as Redux from "react-redux";

import { errorActions, RootState } from "client/store";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function toErrorMessage(error: Error | null) {
  return error?.message ?? "Oops, something went wrong";
}

export const ErrorToast: React.FC = () => {
  const { error, isOpen } = Redux.useSelector(({ error }: RootState) => error);

  const dispatch = Redux.useDispatch();

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(errorActions.hideToastError());
  };

  return (
    <Snackbar onClose={handleClose} open={isOpen} autoHideDuration={6000}>
      <Alert
        onClose={handleClose}
        elevation={6}
        severity="error"
        variant="filled"
      >
        {toErrorMessage(new Error(error ?? ""))}
      </Alert>
    </Snackbar>
  );
};
